import { render, staticRenderFns } from "./DimissioniProtetteSezioneClinicaEdit.vue?vue&type=template&id=3d4428d4"
import script from "./DimissioniProtetteSezioneClinicaEdit.vue?vue&type=script&lang=js"
export * from "./DimissioniProtetteSezioneClinicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports